import {NgModule, Provider} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {BOHttpClientInterceptor} from "./bo.http.interceptor";
import {RouterModule} from "@angular/router";

const HTTP_CLIENT_INTERCEPTORS: Provider[] = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: BOHttpClientInterceptor,
        multi: true
    }
];

@NgModule({
    imports: [
        HttpClientModule,
        RouterModule
    ],

    providers: [
        HTTP_CLIENT_INTERCEPTORS
    ],

    exports: [
        HttpClientModule
    ]
})
export class BOHttpModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/http/client/bo.http.module.ts